"use client";
import { useState } from "react";

import Check from "@mui/icons-material/Check";
import ContentCopy from "@mui/icons-material/ContentCopy";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";

interface CopyButtonProps {
  value: string;
  title?: string;
  label?: string;
}

export default function CopyButton({
  value,
  title = "Copiază",
  label = undefined,
}: CopyButtonProps) {
  const [copiedRecently, setCopiedRecently] = useState(false);

  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    navigator.clipboard.writeText(value);
    setCopiedRecently(true);
    setTimeout(() => setCopiedRecently(false), 2000);
  };

  return (
    <Tooltip title={title}>
      <Button
        color={copiedRecently ? "success" : "inherit"}
        size="small"
        onClick={handleCopy}
        startIcon={copiedRecently ? (
          <Check fontSize="small" sx={{ color: "success.main" }} />
        ) : (
          <ContentCopy fontSize="small" />
        )}>
        {label || ""}
      </Button>
    </Tooltip>
  );
}
